import { useGetWorkflow } from "@/api/useWorkflow"
import { Flex, Text } from "@/atoms"
import { NAMES_ROUTES, VALUES_PARAMS } from "@/const/routes.constants"
import { isUserAdmin } from "@/domain/user"
import { useTranslation } from "@/hooks/useTranslation"
import { useUser } from "@/hooks/useUser"
import { BulbOutlined } from "@/icons"
import { LinkButton } from "@/molecules/LinkButton"

import styles from "./WorkflowActionIssueDescriptionKai.module.scss"

export const WorkflowActionIssueDescriptionKai = () => {
  const { t } = useTranslation()
  const { user } = useUser()
  const { response, isLoading } = useGetWorkflow()

  if (isLoading || !isUserAdmin(user)) return null

  const { ROOT: GOVERNANCE, WORKFLOWS } = NAMES_ROUTES.GOVERNANCE
  const to = `${GOVERNANCE}/${WORKFLOWS}/${VALUES_PARAMS.NEW_ENTITY}`
  const isExist =
    (response?.data || []).findIndex(
      (item) =>
        (item.filterConditions || []).findIndex(
          (condition) => condition?.kaiMarkedAsFalsePositive === "YES"
        ) !== -1
    ) !== -1

  if (isExist) return null

  return (
    <Flex
      className={styles.container}
      data-component-id="WorkflowActionIssueDescriptionKai"
    >
      <Flex
        flex={1}
        align="center"
        justify="space-between"
        className={styles.wrapper}
      >
        <Flex gap={12} align="center">
          <BulbOutlined className={styles.icon} />
          <Text>{t("triage.drawer.kai.sast.actions.workflow")}</Text>
        </Flex>
        <LinkButton
          to={to}
          type="default"
          state={{
            prePopulateData: {
              name: "Dismiss Issues Kai Flagged as Likely False Positive",
              trigger: {
                category: "Event_Driven",
                type: "Vulnerable_Code"
              },
              currentScope: "all",
              filterConditions: [{ kaiMarkedAsFalsePositive: "Yes" }],
              actions: [
                {
                  type: "dismiss",
                  values: {
                    reason:
                      "Kai flagged this issue as irrelevant, for more details see Kai's description."
                  }
                }
              ]
            }
          }}
        >
          {t("settings.automatedActions.table.actions.create")}
        </LinkButton>
      </Flex>
    </Flex>
  )
}
